export const WHATSAPP_NUMBER = "916267998659";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT_MSG =
  "Hi HR99 Global! I'd like to discuss a requirement with your team.";

export const WA_RESUME_MSG =
  "Hi HR99 Global! I'm looking for a job opportunity. Sharing my resume with you here.";

export const waLinkForPhone = (phone, text) => {
  const digits = (phone || "").replace(/\D/g, "");
  const num = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
};
